var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.show
      ? _c("div", { staticClass: "base-modal" }, [
          _c("div", { staticClass: "base-modal-wrapper" }, [
            _c(
              "div",
              {
                staticClass: "base-modal-inner",
                class: _vm.modalInnnerStyleClass,
                style: _vm.style,
                on: {
                  animationend: function ($event) {
                    return _vm.emit("transition-ended")
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "base-modal-header text-center" },
                  [
                    _vm.closeable
                      ? [
                          _c("font-awesome-icon", {
                            staticClass: "base-modal-close-action",
                            attrs: { icon: "times", size: "1x" },
                            on: {
                              click: function ($event) {
                                return _vm.emit("on-cancel-click")
                              },
                            },
                          }),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.icon || _vm.iconImg
                      ? [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-8 offset-2" }, [
                              _c(
                                "div",
                                { staticClass: "base-modal-icon-wrapper mb-2" },
                                [
                                  _vm.icon != null
                                    ? _c("font-awesome-icon", {
                                        attrs: { icon: _vm.icon, size: "2x" },
                                      })
                                    : _vm.iconImg != null
                                    ? _c("img", {
                                        attrs: {
                                          src: _vm.iconImg,
                                          alt: "Modal Header",
                                          width: "40",
                                          height: "40",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]),
                          ]),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "h2",
                      { staticClass: "mb-2 mt-2 text-capitalize" },
                      [_vm._t("header")],
                      2
                    ),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "base-modal-content",
                    class: { "px-4 pb-4": !_vm.fluid },
                  },
                  [_vm._t("content")],
                  2
                ),
                _vm._v(" "),
                _vm.footerSlot
                  ? [
                      _c("div", { staticClass: "base-modal-actions p-4" }, [
                        _c(
                          "div",
                          { staticClass: "base-modal-actions-inner" },
                          [_vm._t("footer")],
                          2
                        ),
                      ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }